"use client";

import type { Variant } from "@raumagarn/formatters";
import { createContext, useContext } from "react";

interface VariantContext {
	currentVariant?: Variant;
	variants: Variant[];
}

export const VariantContext = createContext<VariantContext | null>(null);

export const VariantProvider = VariantContext.Provider;

export const useVariantContext = () => {
	const context = useContext(VariantContext);
	if (!context) {
		throw new Error("useVariantContext must be used within a VariantProvider");
	}
	return context;
};
